import Const from '../constants'
import axiosApiInstance from '@/interceptors'
import {
  InviteParams,
  RegisterMember,
  TempUserParams,
  IUpdateRoleParams,
  RequestJoinParams,
  RequestToJoinParams,
  AdminRegisterMember,
  RequestJoinGetParams,
  MemberNameByGroupParams,
  MemberNameBySearchParams,
} from '@/models'
class GroupMemberService {

  getLoginUserRole(groupId: number) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${groupId}/roles`)
  }

  getAllMembersByGroupId({
    groupId,
    page,
    limit,
    search,
    mention,
    withoutMemberRole,
    kickMemberId,
    created_first,
    userIds,
    onlyAdmin,
    created_by
  }: {
    groupId: string;
    page: number;
    limit: number;
    search?: string;
    mention?: boolean;
    withoutMemberRole?: boolean;
    kickMemberId?: number;
    created_first?: boolean;
    userIds?: string[]
    onlyAdmin?: boolean
    created_by?: boolean
  }) {
    const params = new URLSearchParams({
      filter: 'id;name;last_login_at;last_access_at;to_be_logged_out;employee_number',
      limit: limit.toString(),
      page: page.toString(),
    });

    if (withoutMemberRole) {
      params.append('role', 'manager');
    }
    if (kickMemberId !== undefined && kickMemberId !== -1) {
      params.append('user_leave', kickMemberId.toString());
    }
    if (search) {
      params.append('search', search);
    }
    if (mention) {
      params.append('mention', 'true');
    }
    if (created_first) {
      params.append('created_first', 'true');
    }
    if (userIds) {
      userIds.forEach(id => params.append('user_ids[]', id))
    }
    if (onlyAdmin) {
      params.append('is_admin', 'true')
    }
    if (created_by) {
      params.append('created_by', 'true')
    }

    const url = `${Const.api_url}members/me/groups/${groupId}/members?${params.toString()}`;
    return axiosApiInstance.get(url);
  }

  getInvitedMembersByGroupId(groupId: string) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${groupId}/invite-members`)
  }

  getJoinMembersByGroupId(params: RequestJoinGetParams) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${params.group_link}/join-requests?limit=${params.limit}&page=${params.page}`)
  }

  checkInvitedUserUniqueUrl(token: string) {
    return axiosApiInstance.get(`${Const.api_url}invite-members/${token}`)
  }

  checkJoinRequestUserUniqueUrl(token: string) {
    return axiosApiInstance.get(`${Const.api_url}join-requests/${token}`)
  }

  getMembersName(params: MemberNameBySearchParams) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${params.group_id}/not-in-group-members?search=name:${params.name};name_kana:${params.name}&limit=${params.limit}&page=${params.page}&filter=id;name`)
  }

  getMemberNameByGroup(params: MemberNameByGroupParams) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${params.group_id}/not-in-group-members?group_id=${params.group_search_id}&limit=${params.limit}&page=${params.page}&filter=id;name`)
  }

  findAdminWithoutMe(groupId: string) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${groupId}/has-other-admin`)
  }

  leaveCurrentGroup(groupId: string) {
    return axiosApiInstance.get(`${Const.api_url}members/me/groups/${groupId}/leave`)
  }

  checkExistMails(groupId: string, mails: string[]) {
    return axiosApiInstance.post(`${Const.api_url}members/me/groups/${groupId}​/check-exist-mails`, { mails: mails })
  }

  sendInviteToUser(params: InviteParams) {
    return axiosApiInstance.post(`${Const.api_url}members/me/groups/${params.group_id}/invite-members`, params)
  }

  reInvitedMember(groupId: string, token: string) {
    return axiosApiInstance.put(`${Const.api_url}members/me/groups/${groupId}/invite-members/${token}`)
  }

  delStopInvite(groupId: string, token: string) {
    return axiosApiInstance.delete(`${Const.api_url}members/me/groups/${groupId}/invite-members/${token}`)
  }

  registerAsMemberByAdmin(params: AdminRegisterMember) {
    return axiosApiInstance.post(`${Const.api_url}members/groups/${params.group_id}/admin-registers`, params)
  }

  updateEmployeeNumberByAdmin(group_id: string, params: {
    user_id: number
    employee_number: string
  }) {
    return axiosApiInstance.post(
      `${Const.api_url}members/groups/${group_id}/admin-update-employee-number`,
      params
    )
  }

  registerAsMember(params: RegisterMember) {
    return axiosApiInstance.post(`${Const.api_url}members/registers/${params.type}`, params)
  }

  registerAsTempMember(params: TempUserParams) {
    return axiosApiInstance.post(`${Const.api_url}groups/${params.group_link}/join-requests`, params)
  }

  requestJoin(params: RequestJoinParams) {
    return axiosApiInstance.post(`${Const.api_url}members/me/groups/${params.group_link}/join-requests`, params)
  }

  approvalJoinRequest(params: RequestToJoinParams) {
    return axiosApiInstance.put(`${Const.api_url}members/me/groups/${params.group_link}/join-requests/${params.id}`)
  }

  approvalAllJoinRequest(params: RequestToJoinParams) {
    return axiosApiInstance.put(`${Const.api_url}members/me/groups/${params.group_link}/join-requests-approval-all`)
  }

  deniedJoinRequest(params: RequestToJoinParams) {
    return axiosApiInstance.delete(`${Const.api_url}members/me/groups/${params.group_link}/join-requests/${params.id}`)
  }

  updateMembersRole(params: IUpdateRoleParams) {
    return axiosApiInstance.post(`${Const.api_url}groups/${params.group_id}/update-roles`, params)
  }

  listMembersRole(groupId: string, memberIds: number[]) {
    return axiosApiInstance.post(`${Const.api_url}members/me/groups/${groupId}/list-role-member-group`, { member_ids: memberIds })
  }

  removeMember(groupId: string, memberId: number) {
    return axiosApiInstance.post(`${Const.api_url}members/me/groups/${groupId}/delete-user/${memberId}`)
  }

  updateAuthorTopicLeaveGroup(groupId: string, payload: { user_id: number }) {
    return axiosApiInstance.post(
      `${Const.api_url}members/me/group/${groupId}/update-user-create-topics`,
      payload
    )
  }

  checkUserHasCreateAnyTopic(groupId: string, userLeave?: number) {
    return axiosApiInstance.get(
      `${Const.api_url}members/me/group/${groupId}/check-user-create-topics`, {
        params: {
          user_leave: userLeave
        }
      }
    )
  }
}

export default new GroupMemberService
